// extracted by mini-css-extract-plugin
module.exports = {"surface":"HeaderLogo_surface__w5MQT","locked":"HeaderLogo_locked__1LdS7"};